export default __webpack_public_path__ + "static/media/34_As.58813d8a.svg";